var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCaution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.5V13M12 16V16.5M10.0549 5.10086L3.41132 16.1689C3.09404 16.6975 2.88237 17.3171 3.07132 17.9039C3.46291 19.12 4.60413 20 5.95095 20H18.049C19.3959 20 20.5371 19.12 20.9287 17.9039C21.1176 17.3171 20.906 16.6975 20.5887 16.1689L13.9451 5.10086C13.0641 3.63305 10.9359 3.63305 10.0549 5.10086Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaution);
export default __webpack_public_path__ + "static/media/caution.cd6bed06128292f54066cf6d44e6a916.svg";
export { ForwardRef as ReactComponent };